import React, { PureComponent } from "react";
import { Col, Card, Row, Tabs, Pagination, Empty, Button, message } from 'antd';
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import './index.scss';
import { infoDetail } from "./fieldConfig";

export default class Index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataDetail: {}
        };
    }

    componentDidMount() {
        const { } = this.props

        this.getDetail()
    }
    getDetail = (data) => {
        const { match: { params: { id } } } = this.props
        const { } = this.state
        // let params = {}
        Http.get(Request.educationTrainingAllianceDetail(), { id }, obj => {
            if (obj.code == 200) {
                // this.setState({ dataDetail: obj.data.data })
                this.setState({ dataDetail: infoDetail() })
                console.log('------getDetail------', obj.data.data);
            } else {
                message.error(obj.msg || obj.message || "请求失败，请重试");
            }
        });

    }
    renderListInfo = (data) => {

    }

    handleClick = () => {
        const { history } = this.props
        history.goBack()
    }

    render() {
        const { handleClick } = this
        const { dataDetail } = this.state

        return (
            <div className="education_training_alliance_detail">
                <div className="title_banner">
                    <h2>退役军人教育培训联盟</h2>

                </div>
                <div className="unit_container">
                    <div className="unit_name">{dataDetail?.institutionName}</div>
                    <div className="go_back" onClick={handleClick}>返回</div>
                    <div className="unit_introduce">
                        <div className="alliance_duties introduce_item">
                            <span className="item_title">联盟职务</span>
                            <span className="break_line"></span>
                            <span>{dataDetail?.leaguePosition}</span>
                        </div>
                        <div className="training_programs introduce_item">
                            <span className="item_title">主要承接培训项目</span>
                            <span className="break_line"></span>
                            <span>{dataDetail?.trainingPrograms}</span>
                        </div>
                        <div className="unit_profile introduce_item">
                            <span className="item_title">单位简介</span>
                            <span className="break_line"></span>
                            <span>{dataDetail?.briefIntroduction}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
